import { useState, useEffect } from 'react';
import { auth, db } from '../services/firebase.js';
import { doc, getDoc, collection, query, getDocs, where, orderBy, limit } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';

export function useCourier() {
  const [stats, setStats] = useState(null);
  const [stamps, setStamps] = useState([]);
  const [courierInfo, setCourierInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        await fetchCourierData(user.uid);
      } else {
        setIsLoading(false);
        setError('Not logged in');
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchCourierData = async (userId) => {
  setIsLoading(true);
  try {
    console.log('=== Starting fetchCourierData ===');
    console.log('User ID:', userId);
    
    // Get user's courier assignment
    const userDoc = await getDoc(doc(db, 'users', userId));
    console.log('User doc exists?', userDoc.exists());
    console.log('User doc data:', userDoc.data());
    
    if (!userDoc.exists()) {
      throw new Error('User not found');
    }

    const userData = userDoc.data();
    const courierId = userData.courierId;

    if (!courierId) {
      throw new Error('No courier assigned to this user');
    }

    // Get courier info
    console.log('Looking for courier:', courierId);
    const courierDoc = await getDoc(doc(db, 'couriers', courierId));
    console.log('Courier doc exists?', courierDoc.exists());
    console.log('Courier doc data:', courierDoc.data());
    
    if (!courierDoc.exists()) {
      throw new Error('Courier not found');
    }
    
    const courierData = courierDoc.data();
    setCourierInfo({
      id: courierId,
      name: courierData.name || courierData.companyName || 'Unknown Courier',
      email: courierData.contactEmail || courierData.email
    });

      // Get stamps for this courier
      const stampsQuery = query(
        collection(db, 'couriers', courierId, 'stamps'),
        orderBy('createdAt', 'desc'),
        limit(200)
      );

      const stampsSnapshot = await getDocs(stampsQuery);
      const stampsData = stampsSnapshot.docs.map(doc => ({
        id: doc.id,
        code: doc.id,
        ...doc.data()
      }));

      setStamps(stampsData);

      // Calculate stats
      const totalGenerated = stampsData.length;
      const totalPurchased = stampsData.filter(s => s.purchased).length;
      const totalUsed = stampsData.filter(s => s.used).length;

      setStats({
        total_generated: totalGenerated,
        total_purchased: totalPurchased,
        total_used: totalUsed,
        unused_paid: totalPurchased - totalUsed,
        fraud_prevention: totalGenerated - totalPurchased
      });

      setIsLoading(false);
    } catch (err) {
      console.error('Error fetching courier data:', err);
      setError(err.message);
      setIsLoading(false);
    }
  };

  const refreshData = async () => {
    const user = auth.currentUser;
    if (user) {
      await fetchCourierData(user.uid);
    }
  };

  return {
    stats,
    stamps,
    courierInfo,
    isLoading,
    error,
    refreshData,
  };
}

export default useCourier;